// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__CGaXE","bigColWidth":"Table_bigColWidth__GaK2_","biggerColWidth":"Table_biggerColWidth__zNE38","row":"Table_row__1KOgY","col":"Table_col__sfTy1"};